import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { AvailablePeopleSearch, DogsBreederApi, PersonGridDto } from "../../../../../../api";
import { CustomDataTable } from "../../../../../../components";
import { useGlobalData } from "../../../../../../contexts";
import { useApiService, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import { generateAddress } from "../../../../../../utils";

export interface IDogsBreederListPanelProps {
  dogId: number;
  onPersonSelected: (row: PersonGridDto) => void;
}

export const DogsBreederListPanel: React.FunctionComponent<IDogsBreederListPanelProps> = ({
  dogId,
  onPersonSelected,
}) => {
  const api = useApiService(DogsBreederApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [10, 15, 25],
    pageSize: 10,
    sortKeys: { lastName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: AvailablePeopleSearch) =>
      api.getAvailablePeople(
        AvailablePeopleSearch.fromJS({
          ...sObj,
          dogId: dogId,
        })
      ),
    [api, dogId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: PersonGridDto) => (
          <ButtonContainer>
            <Button
              onClick={() => {
                onPersonSelected(row);
              }}
              text={t(ETLCodes.Select)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.LastName),
        fieldName: "lastName",
      },
      {
        header: () => t(ETLCodes.FirstName),
        fieldName: "firstName",
      },
      {
        header: () => t(ETLCodes.Address),
        fieldName: "address",
        render: (row: PersonGridDto) => generateAddress(row.number, row.street, row.city, row.postalCode, row.country),
      },
    ],
    [onPersonSelected, t]
  );
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return <CustomDataTable tableState={tableState} loading={loading} columns={columns} />;
};
